import React from 'react'
import {Icon} from '@chakra-ui/react'

const ManualBookIcon = (props) => {
    return (
        <Icon viewBox="0 0 14 14" fill="none" {...props}>
            <path
                d="M10.499 0.516602C11.5022 0.516778 12.3154 1.33078 12.3154 2.33398V11.667C12.3153 12.6701 11.5021 13.4832 10.499 13.4834H3.49902C2.49594 13.4832 1.68177 12.6701 1.68164 11.667V11.1504H1.16602C0.807031 11.1504 0.515625 10.859 0.515625 10.5C0.515625 10.141 0.807031 9.84961 1.16602 9.84961H1.68164V8.81738H1.16602C0.807112 8.81738 0.515757 8.52587 0.515625 8.16699C0.515625 7.80801 0.807031 7.5166 1.16602 7.5166H1.68164V6.4834H1.16602C0.807031 6.4834 0.515625 6.19199 0.515625 5.83301C0.515757 5.47413 0.807112 5.18262 1.16602 5.18262H1.68164V4.15039H1.16602C0.807031 4.15039 0.515625 3.85898 0.515625 3.5C0.515625 3.14102 0.807031 2.84961 1.16602 2.84961H1.68164V2.33398C1.68164 1.33078 2.49586 0.516783 3.49902 0.516602H10.499ZM9.98242 12.1836H10.499C10.7841 12.1834 11.0155 11.9521 11.0156 11.667V2.33398C11.0156 2.04875 10.7842 1.81756 10.499 1.81738H9.98242V12.1836ZM3.49902 1.81738C3.21383 1.81756 2.98242 2.04875 2.98242 2.33398V2.84961H3.49902C3.85785 2.84979 4.14941 3.14113 4.14941 3.5C4.14941 3.85887 3.85785 4.15021 3.49902 4.15039H2.98242V5.18262H3.49902C3.85777 5.1828 4.14928 5.47425 4.14941 5.83301C4.14941 6.19188 3.85785 6.48322 3.49902 6.4834H2.98242V7.5166H3.49902C3.85785 7.51678 4.14941 7.80812 4.14941 8.16699C4.14928 8.52575 3.85777 8.8172 3.49902 8.81738H2.98242V9.84961H3.49902C3.85785 9.84979 4.14941 10.1411 4.14941 10.5C4.14941 10.8589 3.85785 11.1502 3.49902 11.1504H2.98242V11.667C2.98255 11.9521 3.21391 12.1834 3.49902 12.1836H8.68164V1.81738H3.49902Z"
                fill="currentColor"
            />
            <path
                opacity="0.1"
                d="M8.69922 8.16699L1.9986 8.16699"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
            />
            <path
                opacity="0.1"
                d="M8.69922 5.83301L1.9986 5.83301"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
            />
            <path
                opacity="0.1"
                d="M8.69922 3.5L1.9986 3.5"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
            />
            <path
                opacity="0.1"
                d="M8.69922 10.5L1.9986 10.5"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
            />
        </Icon>
    )
}

export default ManualBookIcon
